module.exports = __webpack_public_path__ + "static/media/foto-trabalhe-conosco.46a31c44.png";